import { computed } from "vue";
export function useDeviceOS() {
  const isClient = typeof window !== "undefined";
  const os = computed(() => {
    if (!isClient) return "unknown";
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return "android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "ios";
    }
    return "unknown";
  });
  return {
    os,
    isAndroid: computed(() => os.value === "android"),
    isIOS: computed(() => os.value === "ios")
  };
}
